<app-title-bar titleText="i18n.base.confirm-email.header"></app-title-bar>
@if (!spinnerService.showSpinner) {
  <div class="row">
    @if (success) {
      <div class="col-lg-4 offset-lg-4 col-md-6 offset-md-3">
        <p class="success-message"><span class="e-icons icon-checkmark me-1"></span>{{ "i18n.base.confirm-email.success-message" | translate }}</p>
      </div>
    }
    @else {
      <div class="col-lg-4 offset-lg-4 col-md-6 offset-md-3">
        <h3>{{ "i18n.base.confirm-email.error-header" | translate }}</h3>
        <p class="error-message"><span class="e-icons icon-warning--alt me-1"></span>{{ "i18n.base.confirm-email.error-message" | translate }}</p>
      </div>
    }
  </div>
}
